import { PhoneNumberProvisioningResultSchema } from "@redotech/redo-onboarding-api/schema/recover/provision-recover-phone-number";
import { RecBusinessInfoObjectSchema } from "@redotech/redo-onboarding-api/schema/recover/recover-config";
import { isValidE164PhoneNumber } from "@redotech/util/phone-number";
import * as z from "zod";

export const ConciergeBusinessInfoSchema = RecBusinessInfoObjectSchema.extend({
  legalEntityName: z.string().min(1),
  ein: z.string().regex(/^\d{9}$/),
});

export const ConciergeProvisionPhoneNumberInputSchema = z.object({
  businessInfo: ConciergeBusinessInfoSchema,
  address: z
    .object({
      street1: z.string().min(1),
      street2: z.string().optional(),
      city: z.string().min(1),
      state: z.string().min(1),
      zip: z.string().min(1),
      country: z.string().min(1),
    })
    .optional(),
  adminName: z.string().min(1).optional(),
  adminPhone: z
    .string()
    .refine(isValidE164PhoneNumber, "Phone number must be E.164")
    .optional(),
});

export type ConciergeProvisionPhoneNumberInput = z.infer<
  typeof ConciergeProvisionPhoneNumberInputSchema
>;

export const provisionConciergePhoneNumber = {
  name: "provisionConciergePhoneNumber" as const,
  input: ConciergeProvisionPhoneNumberInputSchema,
  output: PhoneNumberProvisioningResultSchema,
};
